document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('.faq__questions-tab-button');

    buttons.forEach((button, i) => {
        const target = document.querySelector(button.getAttribute('data-toggle'));
        if (!target) return;

        if (i === 0) {
            target.classList.add('show');
            button.setAttribute('aria-expanded', 'true');
            target.style.height = target.scrollHeight + 'px';
            target.style.marginTop = '20px';
        }

        button.addEventListener('click', () => {
            const isExpanded = target.classList.contains('show');

            buttons.forEach(btn => {
                const t = document.querySelector(btn.getAttribute('data-toggle'));
                if (t && t !== target) {
                    t.style.height = '0';
                    t.style.marginTop = '0';
                    t.classList.remove('show');
                    btn.setAttribute('aria-expanded', 'false');
                }
            });

            target.classList.toggle('show', !isExpanded);
            button.setAttribute('aria-expanded', String(!isExpanded));
            target.style.height = !isExpanded ? target.scrollHeight + 'px' : '0';
            target.style.marginTop = !isExpanded ? '20px' : '0';
        });
    });
});